module.exports = __webpack_public_path__ + "static/media/lu.1b602322.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/lu.svg
// module id = 2145
// module chunks = 0